<template lang="pug">
  .info-page
    .info-page__head
      .info-page__head-inner
        Breadcrumbs(:list="breadcrumbs")
        h1 {{ title }}

    .info-page__content
      client-only
        .info-page__text(v-if="content" v-html="content")
        slot(v-else)
        InlineSvg.info-page__logo(:src="require('~/assets/img/VVV-logo.svg')")

      .info-page__questions
        .info-page__questions-body
          .info-page__questions-icon
            InlineSvg(:src="require('~/assets/img/icons/question-mark-yellow.svg')")
          .info-page__questions-info
            .info-page__questions-title(v-html="$t('questionsTitle')")
            .info-page__questions-buttons
              Button(is-primary is-purple v-support-button) {{ $t('supportService') }}

</template>

<script>
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs'
export default {
  name: 'InfoPage',

  components: { Breadcrumbs },

  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },

  computed: {
    breadcrumbs () {
      return [
        {
          title: this.title
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.info-page {
  &__questions {
    margin-top: 32px;
    padding: 24px 0;
    border-top: 3px solid #4f5f74;
    border-bottom: 3px solid #4f5f74;

    &-buttons {
      display: flex;
      margin-top: 32px;

      button.button {
        background: $indigo60;
        margin-right: 16px;

        &::before {
          background: transparent;
        }

        &:hover {
          &::before {
            background: linear-gradient(90deg, $blue-grey60, $blue-grey70);
          }
        }
      }
    }

    &-body {
      display: flex;
      align-items: flex-start;
    }

    &-icon {
      margin-right: 24px;

      svg {
        width: 72px;
        height: 72px;

        path {
          &:first-child {
            fill: $white;
            opacity: 1;
          }

          &:last-child {
            fill: $indigo60;
            opacity: 1;
          }
        }
      }
    }

    &-info {
      display: flex;
      flex-direction: column;
    }

    &-title {
      @include heading4;

      color: $white;
    }
  }

  h2 {
    @include heading2;

    font-weight: 500;
    margin: 64px 0 12px;
    color: #b7cce1;

    &:first-child {
      margin-top: 0;
    }
  }

  h3 {
    @include heading4;

    color: #fff;
    margin: 24px 0 12px;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    @include text-info120;

    color: white;
    font-weight: 500;
    margin: 12px 0;

    &:first-child {
      margin-top: 0;
    }
  }

  table {
    width: 100%;
    border: none;
    margin: 12px 0;

    td,
    th {
      @include text-info100;

      color: $blue-grey05;
      padding: 12px;
      border-bottom: 1px solid $blue-grey10;
    }

    th {
      text-align: center;
      font-weight: bold;
    }
  }

  ul,
  ol {
    margin: 24px 0 16px;
  }

  li {
    @include text-display120;

    color: white;
    line-height: 144%;
    list-style-type: disc;
    padding-left: 8px;
    margin-left: 32px;
    margin-bottom: 8px;
    font-weight: 500;
  }

  ol li {
    list-style-type: decimal;
  }

  ul li {
    list-style-type: disc;
  }

  &__image {
    padding: 15px 0;
    width: 100%;

    img {
      display: block;
      margin: 0 auto;
      width: 80%;
    }
  }

  &__head {
    padding: 32px 24px 48px;
    background: $blue-grey70;

    @media (min-width: 1500px) {
      margin-left: calc(-100vw / 2 + 1500px / 2 + 40px);
      margin-right: calc(-100vw / 2 + 1500px / 2);
      width: calc(100vw - 65px) !important;
    }

    &-inner {
      max-width: 992px;
      margin: 0 auto;

      > h1 {
        @include heading1;

        color: white;
        margin-top: 48px;
      }
    }
  }

  &__content {
    max-width: 992px;
    padding: 64px 128px;
    box-sizing: border-box;
    margin: 64px auto;
    background: $white10;
    position: relative;
    overflow: hidden;
    border-radius: 8px;

    a {
      color: #54aaff;
      font-weight: 500;
    }

    > svg {
      position: absolute;
      left: -44px;
      width: 300px;
      height: 270px;
      top: -4px;
      z-index: -1;
      opacity: 0.1;

      path {
        fill: $blue-grey20;
      }
    }
  }

  @media (max-width: $breakpointTablet) {
    &__content {
      padding: 64px 24px;
      box-sizing: border-box;
      margin: 64px auto;
      background: $white10;
      position: relative;
      overflow: hidden;
    }
  }

  @media (max-width: $breakpointMobile) {
    &__head {
      padding: 24px 16px 48px;

      &-inner {
        > h1 {
          margin-top: 16px;
        }
      }
    }

    &__content {
      padding: 64px 16px;
      margin: 48px auto;
    }

    &__image {
      img {
        width: 100%;
      }
    }
  }
}
</style>
